/*!
 * yoda-kuaishou-plugin v0.0.5
 * (c) 2020-present By Kuaishou
 * Released under the ISC License.
 */
'use strict';

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

// 针对 bridge 回调做了一些分类，后续如果有其他类型的 bridge 需要特殊处理再新增分类即可
var BRIDGE_TYPE = {
  noCallbackList: ['popBack', 'exitWebView'],
  onClickList: ['setPhysicalBackButton', 'setTopLeftBtn', 'setTopLeftSecondBtn', 'setTopRightBtn', 'setTopRightSecondBtn'],
  handlerList: ['on', 'off']
}; // 针对主 APP 客户端注入的全局变量，作为 namespace 注册前先进行小驼峰命名转化

var GLOBALVAR_2_NAMESPACE = {
  Kwai: 'kwai',
  KwaiAd: 'kwaiAd',
  KwaiAdThird: 'kwaiAdThird',
  KwaiMerchant: 'kwaiMerchant',
  KwaiLive: 'kwaiLive'
};
var NAMESPACE_2_GLOBALVAR = {
  kwai: 'Kwai',
  kwaiAd: 'KwaiAd',
  kwaiAdThird: 'KwaiAdThird',
  kwaiMerchant: 'KwaiMerchant',
  kwaiLive: 'KwaiLive',
  // 以防使用大写 namespace 进行调用，大写的映射关系也加上
  Kwai: 'Kwai',
  KwaiAd: 'KwaiAd',
  KwaiAdThird: 'KwaiAdThird',
  KwaiMerchant: 'KwaiMerchant',
  KwaiLive: 'KwaiLive'
};
var ADD_CB_PARAMS_LIST = {
  // Android 9.0.30 及以上版本已修复
  home: ['changeActivityTemplate', 'isActivityTabActive']
};

var ua = navigator.userAgent;
var noCallbackList = BRIDGE_TYPE.noCallbackList,
    onClickList = BRIDGE_TYPE.onClickList,
    handlerList = BRIDGE_TYPE.handlerList;
function isFunction(fn) {
  return typeof fn === 'function';
}
function isOldWebView() {
  return !window.__yodaBridge__;
}
function isIOS() {
  return !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
}
/**
 *
 * 生成唯一的id
 * @export
 * @returns
 */

function generateUUID() {
  var rc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  // https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript/2117523#2117523
  var d = new Date().getTime();

  if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
    d += performance.now(); // use high-precision timer if available
  }

  var pattern = rc ? 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx' : 'xxxxxxxx_xxxx_4xxx_yxxx_xxxxxxxxxxxx';
  return pattern.replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
  });
}
/**
 *
 * 生成临时唯一的方法挂接到window上，给客户端回调用
 * @name generateUUCallbackFunction
 * @private
 * @param {function} callback 回调函数，客户端方法执行完后会执行该方法
 * @param {boolean} notDelete 是否删除当前回调，留在当前页面的内存中
 * @param {string} bridge 的命名空间和方法名，方便后续问题排查
 * @param {string} 回调方法对应的唯一ID
 * @returns
 */

function generateUUCallbackFunction(callback, notDelete, callbackName) {
  var callbackId = generateUUID(false);
  var name = "yoda_kuaishou_plugin_callback_".concat(callbackName, "_").concat(callbackId);

  window[name] = function (data) {
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) {
        console.warn(e); // eslint-disable-line
      }
    }

    if (isFunction(callback)) {
      callback.call(window, data);
    } else if (typeof callback === 'string' && isFunction(window[callback])) {
      window[callback].call(window, data);
    }

    if (!notDelete) {
      delete window[name];
    }
  };

  return name;
} // 用于 showDialog 相关 api 中，将回调转化成接口需要的 URL

function transformFuncToURL(btn, callbackName) {
  var tmpBtn = btn;

  if (btn && Array.isArray(btn.actions)) {
    tmpBtn.actions = btn.actions.map(function (action) {
      if (action && action.url && isFunction(action.url)) {
        action.url = generateUUCallbackFunction(action.url, true, callbackName);
      }

      return action;
    });
  }

  return tmpBtn;
}
var handlerCbMap = {}; // 事件相关 api 中处理 handler

function generateHandlerFunction(callback, bridge) {
  var handlerName = '';
  var cb = null;
  Object.keys(handlerCbMap).some(function (cbName) {
    var handlerCb = handlerCbMap[cbName];

    if (handlerCb === callback) {
      cb = handlerCb;
      handlerName = cbName;
      return true;
    }
  }); // 当传递的 handler 回调之前已经挂载过，就不再重新挂载，重新生成 handler 回调名

  if (cb !== callback && callback) {
    var name = generateUUCallbackFunction(callback, true, bridge);
    handlerCbMap[name] = callback;
    handlerName = name;
  }

  return handlerName;
}
/**
 * bridge 调用参数预处理，针对几类特定 bridge 进行处理
 * @name bridgeParamsHandler
 * @private
 * @param {string} namespace 命名空间
 * @param {string} bridge 桥名
 * @param {Object} 调用参数
 * @param {function} bridge 本身调用的回调
*/

function bridgeParamsHandler(namespace, bridgeName, params, invokeCallback) {
  var handledParams = _objectSpread2({}, params);

  var callbackName = "".concat(namespace, "_").concat(bridgeName); // 特殊适配 Kwai 等命名空间下 bridge 回调的传递
  // 回调为 onClick 形式的

  if (onClickList.indexOf(bridgeName) > -1) {
    handledParams.onClick = generateUUCallbackFunction(handledParams.onClick, true, callbackName); // 不允许传递任何参数给 native 的
  } else if (noCallbackList.indexOf(bridgeName) > -1) {
    handledParams = null; // 事件类传 handler 的
  } else if (handlerList.indexOf(bridgeName) > -1) {
    var callbackUUid = generateUUCallbackFunction(invokeCallback, false, callbackName); // 调用 off 桥不传 handler 时，则不能传再对其进行处理

    if (handledParams.handler && isFunction(handledParams.handler)) {
      handledParams.handler = generateHandlerFunction(handledParams.handler, callbackName);
    }

    handledParams.callback = callbackUUid; // showDialog
  } else if (bridgeName === 'showDialog') {
    var _handledParams = handledParams,
        positiveButton = _handledParams.positiveButton,
        negativeButton = _handledParams.negativeButton,
        neutralButton = _handledParams.neutralButton;

    if (positiveButton) {
      handledParams.positiveButton = transformFuncToURL(positiveButton, callbackName);
    }

    if (negativeButton) {
      handledParams.negativeButton = transformFuncToURL(negativeButton, callbackName);
    }

    if (neutralButton) {
      handledParams.neutralButton = transformFuncToURL(neutralButton, callbackName);
    } // 其他默认都是通过 callback 传给 native

  } else {
    var _callbackUUid = generateUUCallbackFunction(invokeCallback, true, callbackName);

    handledParams.callback = handledParams.callback || _callbackUUid;
  }

  return handledParams;
}
/**
 * 比较版本号
 * @param  {string} source 比较源
 * @param  {string} target 比较目标
 * @return {inter} 前者大返回>0, 相等返回0, 前者小返回<0
 */

function compareVersion() {
  var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var sourceArr = source.split('.');
  var targetArr = target.split('.');

  for (var i = 0; i < targetArr.length; i++) {
    if (sourceArr[i] !== targetArr[i]) {
      sourceArr[i] = isNaN(sourceArr[i]) ? 0 : sourceArr[i];
      targetArr[i] = isNaN(targetArr[i]) ? 0 : targetArr[i];
      return sourceArr[i] - targetArr[i];
    }
  }

  return 0;
}

var isInit = false;
var _apis = {};

function getApis() {
  if (isInit) return _apis;
  isInit = true;
  var bridgeMap = {}; // 为避免像 ks-bridge 那样为增加新的 bridge 调用而频繁发版，改为遍历 native 注入的 Kwai 等全局变量上的 bridge

  for (var globalVar in GLOBALVAR_2_NAMESPACE) {
    for (var property in window[globalVar]) {
      var ns = GLOBALVAR_2_NAMESPACE[globalVar];

      if (ns) {
        var config = {}; // kwai.emit data 参数仅支持 string，但由于实际使用习惯直接传对象，故需要 stringify 处理下

        if (ns === 'kwai' && property === 'emit') {
          config.before = function (param) {
            if (param && _typeof(param.data) === 'object' && param.data !== null) {
              param.data = JSON.stringify(param.data);
            }

            return param;
          };
        }

        bridgeMap[ns] = bridgeMap[ns] || {};
        bridgeMap[ns][property] = config; // globalVar 也需要注入，保证不影响类似 yoda.Kwai.xxx 这种方式调用

        bridgeMap[globalVar] = bridgeMap[globalVar] || {};
        bridgeMap[globalVar][property] = config;
      }
    }
  }

  _apis = _objectSpread2({
    webview: {
      open: {
        ksName: 'loadUrlOnNewPage',
        before: function before(opt) {
          var url = opt.url,
              type = opt.type;
          return {
            url: url,
            type: type || 'back'
          };
        }
      },
      close: function () {
        var ksName = isIOS() ? 'exitCurrentWebview' : 'exitWebView';
        return {
          ksName: ksName
        };
      }(),
      backOrClose: {
        ksName: 'popBack'
      },
      openKsWebview: {
        ksName: 'loadUrlOnNewPage'
      }
    },
    tool: {
      canIUse: {
        ksName: 'isSupport',
        after: function after(res) {
          return {
            result: 1,
            canUse: !!res
          };
        }
      },
      setClipBoard: {}
    },
    ui: {
      setSlideBackBehavior: {
        ksName: 'setSlideBack',
        before: function before(opt) {
          var behavior = opt.behavior;
          return {
            enabled: behavior !== 'none'
          };
        }
      },
      showToast: {},
      showDialog: {
        before: function before(opt, cb) {
          var _opt$title = opt.title,
              title = _opt$title === void 0 ? '' : _opt$title,
              _opt$content = opt.content,
              content = _opt$content === void 0 ? '' : _opt$content,
              _opt$confirmButtonTex = opt.confirmButtonText,
              confirmButtonText = _opt$confirmButtonTex === void 0 ? '确定' : _opt$confirmButtonTex,
              _opt$cancelButtonText = opt.cancelButtonText,
              cancelButtonText = _opt$cancelButtonText === void 0 ? '取消' : _opt$cancelButtonText,
              _opt$showCancelButton = opt.showCancelButton,
              showCancelButton = _opt$showCancelButton === void 0 ? true : _opt$showCancelButton;
          var param = {
            title: title,
            content: content,
            positiveButton: {
              text: confirmButtonText,
              colorType: 'positive',
              actions: [{
                actionType: 'JS_CALLBACK',
                url: function url() {
                  cb({
                    result: 1,
                    target: 'confirm'
                  });
                }
              }]
            }
          };

          if (showCancelButton) {
            param.negativeButton = {
              text: cancelButtonText,
              colorType: 'negative',
              actions: [{
                actionType: 'JS_CALLBACK',
                url: function url() {
                  cb({
                    result: 1,
                    target: 'cancel'
                  });
                }
              }]
            };
          }

          return param;
        }
      },
      showBottomSheet: {}
    },
    event: {
      dispatchEvent: {
        ksName: 'emit',
        before: function before(param) {
          if (param && _typeof(param.data) === 'object' && param.data !== null) {
            param.data = JSON.stringify(param.data);
          }

          return param;
        }
      }
    },
    merchant: {
      getSidToken: {},
      reqSessionStickyOnTopWithThread: {},
      querySessionIsStickyOnTop: {}
    },
    mediaInteraction: {
      saveImage: {},
      selectImage: {}
    }
  }, bridgeMap);
  return _apis;
}

var noop = function noop() {};

var origin = function origin(o) {
  return o;
};

function callNative(name, bridgeName, options, cb) {
  var opts = bridgeParamsHandler(name, bridgeName, options, cb); //  isSupport 为 ks-bridge 自定义方法，插件不再依赖 ks-bridge，故需要单独处理 isSupport 调用

  if (bridgeName === 'isSupport') {
    var checkedBridge = options.name;
    cb(!!window[name][checkedBridge]);
    return;
  } else if (!window[name] || !window[name][bridgeName]) {
    // 当该方法不存在时, 直接回调
    handleError(opts);
    return;
  }

  try {
    // opts 为空表示当前 bridge 调用不能传任何参数，否则 native 调用报错
    if (!opts) {
      window[name][bridgeName]();
    } else {
      var strParam;

      try {
        strParam = JSON.stringify(opts);
      } catch (e) {
        e.message += ' in JSON.stringify';
        throw e;
      }

      window[name][bridgeName](strParam);
    }
  } catch (e) {
    handleError(opts);
    setTimeout(function () {
      e.message += " (from yoda-kuaishou-plugin window.".concat(name, ".").concat(bridgeName, ")"); // 异步上报错误 不阻断当前代码

      throw e;
    });
  }
}

function handleError(opts) {
  var language = window.navigator && (window.navigator.languages || window.navigator.language) || [];
  var errorMsg = language.length && language.indexOf('zh') === -1 && language.indexOf('zh-CN') === -1 ? 'Error occurred, please upgrade your app' : '出错啦, 请升级客户端至最新版本';
  opts.callback && window[opts.callback] && window[opts.callback](JSON.stringify({
    result: 127000,
    error_msg: errorMsg
  }));
} // 在旧 webview 中调用 yoda bridge，不走 yoda 内部的 invoke 与 native 通信
// 所以在 beforeInvoke 中直接走 window.xxx 调用


function invoke(ns, api, params, callback) {
  var globalVar = NAMESPACE_2_GLOBALVAR[ns] || 'Kwai';
  var name = api.name,
      ksName = api.ksName,
      _api$before = api.before,
      before = _api$before === void 0 ? origin : _api$before,
      _api$after = api.after,
      after = _api$after === void 0 ? origin : _api$after;
  var bridgeName = ksName || name;

  if (isFunction(before)) {
    // 对调用参数进行预处理
    params = before(params);
  }

  var cb = noop;

  if (isFunction(callback)) {
    cb = function cb(res) {
      var handledRes = res;

      if (isFunction(after)) {
        // 对响应参数进行预处理
        handledRes = after(res);
      }

      callback(handledRes);
    };
  }

  if (bridgeName) {
    callNative(globalVar, bridgeName, params, cb);
  } else {
    throw new Error('invoke: 未指定调用调用 bridge');
  }
}
function beforeInvoke(invokeConfig, next) {
  var yoda = this;

  if (isOldWebView()) {
    var apis = getApis(); // call 全局变量上挂载的方法, 不执行next

    var namespace = invokeConfig.namespace,
        name = invokeConfig.name,
        params = invokeConfig.params,
        callbackId = invokeConfig.callbackId;
    var apiMap = apis[namespace];
    var api = apiMap && apiMap[name];
    var callback = yoda._callbacks && yoda._callbacks[callbackId] || noop;

    if (api) {
      // TODO 检查 params 结构，防止后续解析时报错
      var param = params || {};
      api.name = name;
      invoke.call(yoda, namespace, api, param, callback);
    } else {
      throw new Error("invoke\uFF1Ayoda.".concat(namespace, ".").concat(name, "\u4E0D\u5B58\u5728"));
    }

    return;
  } else {
    var _namespace = invokeConfig.namespace,
        _name = invokeConfig.name,
        _params = invokeConfig.params,
        _callbackId = invokeConfig.callbackId;
    var ns = NAMESPACE_2_GLOBALVAR[_namespace]; // 需要处理回调兼容的桥加到 ADD_CB_PARAMS_LIST 即可

    var addCbParamsBridges = ADD_CB_PARAMS_LIST[_namespace] || [];

    if (ns || addCbParamsBridges.indexOf(_name) > -1) {
      // 实际调用前需要将 register 中改写的 namespace 改回来
      var originalNamespace = ns || _namespace;
      var invokeCallback = yoda._callbacks[_callbackId];
      invokeConfig.namespace = originalNamespace; // 参数预处理

      invokeConfig.params = bridgeParamsHandler(originalNamespace, _name, _params, invokeCallback);
      var ua = navigator.userAgent || '';

      var _ref = ua.match(/Kwai\/([\d+.*]+)/) || [],
          _ref2 = _slicedToArray(_ref, 2),
          _ref2$ = _ref2[1],
          appVer = _ref2$ === void 0 ? '' : _ref2$;

      var defaultVer = '7.7.30'; // 比较版本号
      // 7730 以上版本不需要做兼容处理
      // 兼容方式注册的桥，双端只关注 params.callback，yoda 方式注册的桥只关注 invoke callbackId

      if (appVer && compareVersion(appVer, defaultVer) < 0) {
        // 在 js-sdk 层将桥调用的回调方法转到 params 后，需要将 callbackId 重置下
        // 主要处理部分只回调一次的桥（回调执行一次后会被 delete），如果 params.callback 和 invokeCallback 指向一个回调
        // 可能会导致 params.callback 还未执行，回调已被 delete
        var tmpCbKey = '__yoda_kuaishou_plugin_tmp_cb__';
        yoda._callbacks[tmpCbKey] = yoda._callbacks[tmpCbKey] || noop;
        invokeConfig.callbackId = tmpCbKey; // 需要额外挂到 window 上是因为 iOS 可能会去 window 上找该回调

        window.__yoda_kuaishou_plugin_tmp_cb__ = noop;
      }
    } else if (_namespace === 'tool' && _name === 'canIUse') {
      // 针对 canIUse 特殊适配 GLOBALVAR_2_NAMESPACE 的全局变量
      if (NAMESPACE_2_GLOBALVAR[_params.namespace]) {
        _params.namespace = NAMESPACE_2_GLOBALVAR[_params.namespace];
      }
    }
  }

  next();
}

// yoda 的 resume、pause，对应到旧 webview 中对应多种事件
var eventsMap = {
  resume: ['native_foreground', 'native_reentry'],
  pause: ['native_background', 'native_leave']
};

function addEventListener(type, handler, callback) {
  if (eventsMap[type]) {
    eventsMap[type].forEach(function (eventName) {
      invoke('kwai', {
        name: 'on'
      }, {
        type: eventName,
        handler: handler
      }, callback);
    });
  } else {
    invoke('kwai', {
      name: 'on'
    }, {
      type: type,
      handler: handler
    }, callback);
  }
}

function removeEventListener(type, handler, callback) {
  if (eventsMap[type]) {
    eventsMap[type].forEach(function (eventName) {
      invoke('kwai', {
        name: 'off'
      }, {
        type: eventName,
        handler: handler
      }, callback);
    });
  } else {
    invoke('kwai', {
      name: 'off'
    }, {
      type: type,
      handler: handler
    }, callback);
  }
}

function initEvents(yoda) {
  yoda.event = yoda.event || {};
  yoda.event.addEventListener = addEventListener.bind(yoda);
  yoda.event.removeEventListener = removeEventListener.bind(yoda);
}

// init hook
function beforeInit(initConfig, next) {
  var yoda = this; // 在旧 webview 中由于无法走 yoda 自身的 init，从而导致无法在 yoda 上挂载相应 bridge
  // 所以在 beforeInit 中通过 yoda.register 进行相应 bridge 挂载

  if (isOldWebView()) {
    var apis = getApis();
    initEvents(yoda);

    for (var namespace in apis) {
      var apiList = apis[namespace];

      for (var name in apiList) {
        var api = apiList[name];

        if (api) {
          yoda.register({
            namespace: namespace,
            name: name,
            // 该参数会让走 callback
            // 由于主 APP 原部分 bridge 无法走 promise
            multiCallback: true
          });
        }
      }
    } // 手动触发 yoda ready


    yoda._readyResolve();

    return;
  }

  next();
}

function beforeRegister(registerApi, next) {
  var yoda = this;

  if (yoda.isInYoda) {
    var _ref = registerApi || {},
        namespace = _ref.namespace,
        name = _ref.name;

    var ns = GLOBALVAR_2_NAMESPACE[namespace];

    if (ns) {
      if (ns === 'kwai' && name === 'emit') {
        registerApi.before = function (param) {
          if (param && _typeof(param.data) === 'object' && param.data !== null) {
            param.data = JSON.stringify(param.data);
          }

          return param;
        };
      } // 兼容 kwai、kwaiLive 等命名空间大小写


      registerApi.namespace = ns;
    }
  }

  next();
}
function afterRegister(registerApi) {
  var yoda = this;

  if (yoda.isInYoda) {
    var _ref2 = registerApi || {},
        namespace = _ref2.namespace,
        name = _ref2.name;

    var globalVar = NAMESPACE_2_GLOBALVAR[namespace];

    if (globalVar) {
      // 为使得桥命名空间是小驼峰格式而改变了 yoda 上注册的命名空间
      // 为了不影响类似 yoda.Kwai.xxx 这种方式调用，将 yoda.kwai.xxx 赋值给 yoda.Kwai
      yoda[globalVar] = yoda[globalVar] || {};
      yoda[globalVar][name] = yoda[namespace][name];
    }
  }
}

var ksYodaWrapper = {}; // 判断是否是旧 webview，如果是则需要通过 yoda 的 plugin 方法增加 hooks
// 在 hooks 中，让调用 bridge 直接走类似 window.Kwai.xxx 等方式

if (isOldWebView()) {
  ksYodaWrapper = {
    beforeInit: beforeInit,
    beforeInvoke: beforeInvoke
  };
} else {
  // 在 yoda 环境下需要额外兼容处理下 kwai、kwaiLive 等命名空间大小写，emit 调用参数预处理等
  ksYodaWrapper = {
    beforeRegister: beforeRegister,
    afterRegister: afterRegister,
    beforeInvoke: beforeInvoke
  };
}

var ksYodaWrapper$1 = ksYodaWrapper;

module.exports = ksYodaWrapper$1;
